import React from "react";
import { CheckCircle, Circle } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Validate password against requirements
 */
export const validatePassword = (password, confirmPassword) => {
  const validateLength = password.length >= 8;
  const validateUpper = /[A-Z]/.test(password);
  const validateSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const passwordsMatch = password === confirmPassword && password.length > 0;
  const allValid =
    validateLength && validateUpper && validateSymbol && passwordsMatch;

  return {
    validateLength,
    validateUpper,
    validateSymbol,
    passwordsMatch,
    allValid,
  };
};

/**
 * V2 styled password validation checklist
 */
export default function V2PasswordValidation({ password, confirmPassword }) {
  const { t } = useTranslation();
  const { validateLength, validateUpper, validateSymbol, passwordsMatch } =
    validatePassword(password, confirmPassword);

  const requirements = [
    { label: t("auth.passwordValidation.minLength"), valid: validateLength },
    { label: t("auth.passwordValidation.uppercase"), valid: validateUpper },
    { label: t("auth.passwordValidation.symbol"), valid: validateSymbol },
    { label: t("auth.passwordValidation.match"), valid: passwordsMatch },
  ];

  return (
    <ul className="space-y-2">
      {requirements.map((req, index) => (
        <li
          key={index}
          className={`flex items-center gap-2 text-sm transition-colors duration-150 ${
            req.valid ? "text-green-600" : "text-[#9CA3AF]"
          }`}
        >
          {req.valid ? (
            <CheckCircle size={16} className="flex-shrink-0" />
          ) : (
            <Circle size={16} className="flex-shrink-0" />
          )}
          {req.label}
        </li>
      ))}
    </ul>
  );
}
